import { h, Component } from 'preact';
import Content from '../content/content';
import Border from '../border/border';
import styles from './about.css';

export default class About extends Component {
  render() {
    return (<div className={styles.container} id="page-about">
      <Content>
        <div className={`flex ${styles.content}`}>
          <img className={styles.heads} src="/assets/heads.png" alt="Trouble Brewing" />
          <div>
            <h2 className={styles.title}>Who we are</h2>
            <p>We’re a Singapore-based company that specialises in creating high quality beer that’s personalised for businesses and events, big and small.</p>
            <p>Our mission is to help brands promote themselves over great tasting beer – because we reckon the only thing better than doing business over a beer, is when it’s your own branded beer. From the look of the bottle right down to the recipe and flavours, we can help you create the perfect brew for your brand.</p>
            <p>Find out more about how we can brew some trouble for your business below...</p>
          </div>
        </div>
      </Content>
      <Border color="red" />
    </div>);
  }
}



// WEBPACK FOOTER //
// ./components/about/about.jsx